import { DataValidationModel } from './data-validation.models';

export class DataValidationRequest {
    data: DataValidationModel[] = [];
    token: string;
    
    constructor() {}
    
}